/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    shape, string, number,
    bool, arrayOf, func, object,
    array,
} from 'prop-types';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FormControlLabel } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import ReactHtmlParser from 'react-html-parser';
import { bindActionCreators, compose } from 'redux';
import Image from '../../../../common/Image';
import classList from '../../../../utils/classList';
import { rowSpacing } from '../../../../style/variables';
import { main as mainStyle } from '../../../../style/main';
import { deepObjectExtend, isEmpty } from '../../../../utils/object';
import { decode as htmlDecode } from '../../../../utils/htmlEntity';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import configEnv from '../../../../config';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { emitCustomTrackingEvent } from '../../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import PriceBreakDownUi from '../../../../../../components/GraphqlComponents/GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceBreakDownUi';

const { PERSIST_KEY } = configEnv;

const styles = ({ typography, palette }) => deepObjectExtend(mainStyle(typography, palette), {
    productWrapper: {
        padding: '0',
        overflow: 'hidden',
        // textAlign: 'center',
        '& button.addToCartBtn': {
            whiteSpace: 'nowrap',
            maxWidth: '175px',
            width: '100% !important',
            margin: '0 auto !important',
            float: 'none !important',
        },
        '& .compareProduct': {
            paddingLeft: 0,
            '& svg': {
                width: 20,
            },
        },
    },
    productImageWrapper: {
        position: 'relative',
        cursor: 'pointer',
        '& .quickView': {
            display: 'none',
            position: 'absolute',
            top: 0,
            right: 0,
            backgroundColor: palette.cta1,
            color: palette.common.white,
            textTransform: 'uppercase',
            padding: '4px',
            opacity: 0.7,
        },
        '&:hover': {
            '& .quickView': {
                display: 'inline-block',
            },
        },
    },
    productImage: {
        width: '100%',
        minHeight: '195px',
    },
    productName: {
        textAlign: 'left',
    },
    status: {
        'margin-bottom': rowSpacing,
        'text-transform': 'uppercase',
        'font-size': '12px !important',
    },
    price: {
        fontWeight: 'bold',
        textAlign: 'left',
    },
    compare: {
        textAlign: 'left',
        '& .compare-text': {
            display: 'inline-block',
            textDecoration: 'underline',
            cursor: 'pointer',
        },
        '& .non-compare-text': {
            display: 'inline-block',
        },
    },
    nonCompare: {
        display: 'none',
    },
    headerTitle: {
        height: '28px',
        fontSize: '14px',
        fontWeight: 'bold',
        lineHeight: '28px',
    },
});

class Recommendation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comparedProducts: [],
            hasComparedId: [],
        };
    }

    checkBoxClicked = (product, value) => {
        const { hasComparedId, comparedProducts } = this.state;
        let selectedProducts = [];
        selectedProducts = [...comparedProducts];
        if (selectedProducts.some((hasCheck) => hasCheck === product)) {
            selectedProducts = selectedProducts.filter((check) => check !== product);
        } else {
            selectedProducts.push(product);
        }
        this.setState({ comparedProducts: selectedProducts });

        let checkedArr = [];
        checkedArr = [...hasComparedId];
        if (checkedArr.some((check) => check === value)) {
            checkedArr = checkedArr.filter((check) => check !== value);
        } else {
            checkedArr.push(value);
        }
        this.setState({ hasComparedId: checkedArr });

        if (checkedArr.length > 3) {
            checkedArr.shift();
        }

        return null;
    };

    quickView = (product, recipient, products) => {
        const { handleGiftListRecommendationClicked } = this.props;
        const quickViewProducts = [...products];
        const index = quickViewProducts.findIndex((p) => p.id === product.id);
        if (index === -1) {
            quickViewProducts.unshift(product);
        }
        handleGiftListRecommendationClicked(
            product,
            recipient,
        );
    };

    // this function will show comparison between selected products
    compareViewProduct = (product, recipient, products) => {
        const { handleGiftListRecommendationClicked, checkProductClick, nonCheckProductClick } = this.props;
        const { comparedProducts, hasComparedId } = this.state;
        const isCompareId = hasComparedId.includes(product.id);
        if (comparedProducts.length > 1 && isCompareId) {
            let hasComparedProducts = [...products];
            const index = hasComparedProducts.findIndex((p) => p.id === product.id);
            if (index === -1) {
                hasComparedProducts.unshift(product);
            }

            // Limit to 3 products for comparison
            if (hasComparedProducts.length > 3) {
                hasComparedProducts = hasComparedProducts.slice(0, 3);
            }
            handleGiftListRecommendationClicked(
                product,
                recipient,
                hasComparedProducts,
            );
            nonCheckProductClick();
        }
        if (comparedProducts.length === 1) {
            checkProductClick();
        }
    }

    handleAddToCart = (productId, recipient) => {
        const { handleGiftListAddToCart } = this.props;
        handleGiftListAddToCart(productId, recipient);
    };

    handleAddToCartClicked = (product, recipient, specialProduct) => {
        if (specialProduct) {
            const { seoproductDisplayURL, customAttributes } = product;
            const {
                history,
                history: { location: { pathname: giftListURL } },
                remainingRecipient,
                handleConfirmGiftListShopTheSiteClicked,
            } = this.props;
            const recipientWithCounter = { ...recipient, remainingRecipient, giftListURL };
            handleConfirmGiftListShopTheSiteClicked(
                recipientWithCounter,
                seoproductDisplayURL || customAttributes?.parentProduct?.seo?.url,
                false,
            );
            if (seoproductDisplayURL) history.push(seoproductDisplayURL);
            else if (customAttributes?.parentProduct?.seo?.url) history.push(customAttributes?.parentProduct?.seo?.url);
        } else {
            this.handleAddToCart(product.id, recipient);
        }
    };

    headerProduct = (classes, indexProduct, productNumber, currentPartNumber) => {
        let headerTittle = ' ';
        if (productNumber && currentPartNumber) {
            if (indexProduct === 0) {
                headerTittle = productNumber !== currentPartNumber ? 'Closest Match' : 'Send Same Gift';
            } else if (indexProduct === 1) {
                headerTittle = 'Other Recommendations';
            }
            return <div className={classes.headerTitle}>{headerTittle}</div>;
        }
        return null;
    }

    productTemplate = (
        classes,
        isRecommended,
        product,
        recipient,
        handleGiftListRecommendationClicked,
        indexProduct,
    ) => {
        const {
            id,
            name,
            image,
            status,
            price,
            discountPrice,
            crossedPrice,
            sku,
            customAttributes: { personalization, parentProduct },
            customAttributes,
            hasItemSendPrevious,
        } = product;
        const {
            handleTrackEvent, flags, ldClient, emitCustomClickTrackingEvent, salesforceAPIResponse,
        } = this.props;
        const { comparedProducts, hasComparedId } = this.state;
        if (comparedProducts.length > 3) {
            comparedProducts.shift();
        }
        const hasProduct = recipient.products || [];
        const urlDecode = name || '';
        const newName = htmlDecode(urlDecode);
        const imageURL = (image) ? image.replace(/^http[s]?:/, 'https:') : '';
        const isCompareId = hasComparedId.includes(product.id);
        const ageVerifyFlag = (!isEmpty(customAttributes) && customAttributes?.ageVerifyFlag) ? customAttributes.ageVerifyFlag : 'false';
        const personalizationTemplate = (!isEmpty(personalization) && personalization?.personalizationTemplate) ? personalization.personalizationTemplate : 'N';
        const personalizationType = (!isEmpty(personalization) && personalization?.personalizationType) ? personalization.personalizationType : null;
        const specialProduct = ageVerifyFlag !== 'false'
            || parentProduct?.productType === 'CLUB'
            || parentProduct?.productType === 'COLLECTION'
            || parentProduct?.productType === 'CUSTOM_ASSORTMENT'
            || (
                !['REGULAR_PRODUCT', 'REGULARPRODUCT'].includes(parentProduct?.productType)
                && (
                    personalizationTemplate === 'Y'
                    || personalizationType === 'G'
                    || personalizationType === '0'
                )
            );

        const productNumber = recipient.previousItemMetadata?.partNumber || '';
        const currentPartNumber = recipient?.currentItempartNumber || '';
        const currentSalesforceCampaign = salesforceAPIResponse.find((sfRecipient) => sfRecipient.recipientItemId === recipient.id) ? salesforceAPIResponse.find((sfRecipient) => sfRecipient.recipientItemId === recipient.id) : {};

        let defaultAddToCartLabel = 'Add To Cart';
        if (specialProduct) {
            defaultAddToCartLabel = 'Make Selections';
        }

        if (isRecommended && hasItemSendPrevious) {
            defaultAddToCartLabel = 'Send Same Gift';
        }

        return (
            <React.Fragment key={id}>
                <div
                    className={classList(
                        `${classes.productWrapper}`,
                        isRecommended && hasItemSendPrevious ? `${classes.recommended}` : '',
                    )}
                >
                    {this.headerProduct(classes, indexProduct, productNumber, currentPartNumber)}
                    {/* eslint-disable jsx-a11y/click-events-have-key-events */}
                    <div
                        role="button"
                        tabIndex="-1"
                        className={classes.productImageWrapper}
                        onClick={() => this.quickView(
                            product,
                            recipient,
                            comparedProducts,
                        )}
                    >
                        <div className="quickView">Quick View</div>
                        {
                            imageURL
                            && <Image src={imageURL} alt={newName} className={classes.productImage} />
                        }
                    </div>
                    {newName && (
                        <div className={`${classes.productName} line-clamp-2`}>
                            {ReactHtmlParser(newName)}
                        </div>
                    )}
                    <div>{sku}</div>
                    {status && (<div className={`${classes.status} line-clamp-2`}>{status}</div>)}
                    <div className={classes.price}>
                        {discountPrice && crossedPrice ? (
                            <>
                                <span className="crossed-price">
                                    ${crossedPrice}
                                </span>
                                <span className="discount-price">
                                    ${discountPrice}
                                </span>
                            </>
                        ) : (
                            `$${price}`
                        )}
                    </div>
                    <PriceBreakDownUi
                        dynamicPriceData={product}
                    />
                    <div className={hasProduct.length < 2 ? classes.nonCompare : classes.compare}>
                        <FormControlLabel
                            className="checkbox-wrapper no-margin"
                            control={(
                                <Checkbox
                                    classes={{
                                        root: 'checkbox compareProduct',
                                    }}
                                    color="default"
                                    onChange={() => this.checkBoxClicked(product, product.id)}
                                    checked={isCompareId}
                                    value={product.id}
                                />
                            )}
                        />
                        <div
                            className={!isCompareId ? 'non-compare-text' : 'compare-text'}
                            role="button"
                            tabIndex="-1"
                            onClick={() => this.compareViewProduct(
                                product,
                                recipient,
                                comparedProducts,
                            )}
                        >
                            <span>Compare</span>
                        </div>

                    </div>
                    <Button
                        variant="contained"
                        className={`addToCartBtn ${isRecommended && hasItemSendPrevious ? '' : 'secondary'}`}
                        onClick={() => {
                            if (flags?.experimentGiftListV2?.toLowerCase() === 'control') {
                                ldClient.track('Add to Cart');
                            }
                            this.handleAddToCartClicked(product, recipient, specialProduct);
                            handleTrackEvent({
                                eventCategory: 'Gift List V1',
                                eventAction: 'Item Added',
                                eventLabel: product?.id || '',
                            });
                            const isPrimaryItem = !!(isRecommended && hasItemSendPrevious);
                            handleTrackEvent({
                                eventCategory: 'Gift List V1',
                                eventAction: isPrimaryItem ? 'Primary item added' : 'Recommended item added',
                                eventLabel: product?.id || '',
                            });
                            emitCustomClickTrackingEvent({
                                action: 'Click',
                                partNumber: product?.oGPartNumber,
                                salesforceResponse: currentSalesforceCampaign,
                                page: { type: 'gift-list' },
                                eventSubType: 'campaign-tracking',
                            });
                        }}
                    >
                        {defaultAddToCartLabel}
                    </Button>
                </div>
            </React.Fragment>
        );
    };

    render() {
        const { classes } = this.props;
        const {
            recipient,
            recipient: { addToCart, products },
            handleGiftListRecommendationClicked, sendSameGiftProduct,
        } = this.props;

        const settings = {
            dots: false,
            draggable: true,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 3,
            arrows: true,
            lazyLoad: 'ondemand',
        };
        if (addToCart || isEmpty(recipient) || isEmpty(products)) return null;

        const productNumber = recipient.previousItemMetadata?.partNumber || '';
        const currentPartNumber = recipient?.currentItempartNumber || '';
        let classesCarousel = '';
        if (productNumber && currentPartNumber) {
            classesCarousel = 'carousel-container carousel-border';
        } else if (sendSameGiftProduct) {
            classesCarousel = 'carousel-container';
        } else {
            classesCarousel = 'carousel-container carousel-closest-match';
        }

        return (
            <div className="carouselWrapper">
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <Slider className={`${classesCarousel}`} {...settings}>
                    {products.map((product, index) => this.productTemplate(
                        classes,
                        index === 0,
                        product,
                        recipient,
                        handleGiftListRecommendationClicked,
                        index,
                    ))}
                </Slider>
            </div>
        );
    }
}

Recommendation.defaultProps = {
    addToCart: '',
    history: {},
    recipient: {},
    handleGiftListRecommendationClicked: '',
    handleGiftListAddToCart: () => {},
    handleConfirmGiftListShopTheSiteClicked: () => {},
    checkProductClick: () => {},
    nonCheckProductClick: () => {},
    ldClient: {},
    salesforceAPIResponse: [],
    emitCustomClickTrackingEvent: () => { },
};

Recommendation.propTypes = {
    classes: object.isRequired,
    history: object,
    recipient: shape({
        AddressBookEntryId: string,
        addToCart: string,
        address: shape({
            addressId: string,
            apt: string,
            city: string,
            company: string,
            country: shape({
                id: string,
                name: string,
            }),
            location: shape({
                id: number,
                name: string,
            }),
            state: shape({
                id: string,
                name: string,
            }),
            street: string,
            zipcode: string,
        }),
        addressId: string,
        firstname: string,
        giftArrived: string,
        id: string,
        isNewRecipient: bool,
        lastname: string,
        occasionId: string,
        orderItemId: string,
        products: arrayOf(
            shape({
                content: string,
                crossedPrice: string,
                discountPrice: string,
                id: string,
                image: string,
                name: string,
                parentCatalogEntryId: string,
                partNumber: string,
                price: number,
                seoproductDisplayURL: string,
                sku: string,
                status: string,
            }),
        ),
        type: string,
    }),
    addToCart: string,
    remainingRecipient: number.isRequired,
    handleGiftListRecommendationClicked: func,
    handleConfirmGiftListShopTheSiteClicked: func,
    handleGiftListAddToCart: func,
    checkProductClick: func,
    nonCheckProductClick: func,
    sendSameGiftProduct: bool.isRequired,
    handleTrackEvent: func.isRequired,
    ldClient: object,
    flags: object.isRequired,
    salesforceAPIResponse: array,
    emitCustomClickTrackingEvent: func,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        remainingRecipient: newState.giftList.remainingRecipient,
        addToCart:
            typeof newState.modal.content === 'object'
                ? newState.modal.content.addToCart
                : '',
        salesforceAPIResponse: newState.giftList.salesforceAPIResponse,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListRecommendationClicked: (product, recipient, comparedProducts) => dispatch(EventDispatcher.handleGiftListRecommendationClicked(
        product,
        recipient,
        comparedProducts,
        'desktop',
    )),
    handleGiftListAddToCart: (productId, recipient, closeModal) => dispatch(EventDispatcher.handleGiftListAddToCart(
        productId,
        recipient,
        closeModal,
        'desktop',
    )),
    handleConfirmGiftListShopTheSiteClicked: (recipient, url, dontShowModal) => dispatch(EventDispatcher.handleConfirmGiftListShopTheSiteClicked(
        recipient,
        url,
        dontShowModal,
    )),
    handleTrackEvent: bindActionCreators(trackEvent, dispatch),
    emitCustomClickTrackingEvent: bindActionCreators(emitCustomTrackingEvent, dispatch),
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withStyles(styles),
    withLDConsumer(),
);

export default enhance(Recommendation);
